"use strict";

function _typeof(t) {
    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
    } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
}

function _classCallCheck(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(t, e) {
    for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1;
        n.configurable = !0;
        "value" in n && (n.writable = !0);
        Object.defineProperty(t, _toPropertyKey(n.key), n);
    }
}

function _createClass(t, e, r) {
    return e && _defineProperties(t.prototype, e), r && _defineProperties(t, r), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}

function _toPropertyKey(t) {
    var e = _toPrimitive(t, "string");
    return "symbol" == _typeof(e) ? e : String(e);
}

function _toPrimitive(t, e) {
    if ("object" != _typeof(t) || !t) return t;
    var r = t[Symbol.toPrimitive];
    if (void 0 !== r) {
        var n = r.call(t, e || "default");
        if ("object" != _typeof(n)) return n;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
}

function _callSuper(t, e, r) {
    return e = _getPrototypeOf(e), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(e, r || [], _getPrototypeOf(t).constructor) : e.apply(t, r));
}

function _possibleConstructorReturn(t, e) {
    if (e && ("object" === _typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
}

function _assertThisInitialized(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
}

function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    });
    Object.defineProperty(t, "prototype", {
        writable: !1
    });
    e && _setPrototypeOf(t, e);
}

function _wrapNativeSuper(t) {
    var e = "function" == typeof Map ? new Map : void 0;
    return (_wrapNativeSuper = function (t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, r);
        }

        function r() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }

        return r.prototype = Object.create(t.prototype, {
            constructor: {
                value: r,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(r, t);
    })(t);
}

function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var n = [null];
    n.push.apply(n, e);
    var o = new (t.bind.apply(t, n));
    return r && _setPrototypeOf(o, r.prototype), o;
}

function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
    } catch (t) { }
    return (_isNativeReflectConstruct = function () {
        return !!t;
    })();
}

function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (e) {
        return "function" == typeof t;
    }
}

function _setPrototypeOf(t, e) {
    return (_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
        return t.__proto__ = e, t;
    })(t, e);
}

function _getPrototypeOf(t) {
    return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
}


function mobileOnlyFunction() {
 
}


function desktopOnlyFunction() {
  customElements.get("lta-product-page-fff") || customElements.define("lta-product-page-fff", function (t) {
    function e() {
        var t;
        return _classCallCheck(this, e), (t = _callSuper(this, e)).maxProductMediaToShow = parseInt(t.dataset.maxMediaToShow) || 4, t.mediaSliders = document.querySelectorAll('[id^="MediaGallery-'.concat(t.dataset.section, '"] [data-product-media]')), t.showMoreButtons = t.querySelectorAll("[data-product-show-more-media]"), t.hideLessButton = t.querySelector("[data-product-show-less-media]"), t;
    }
    return _inherits(e, _wrapNativeSuper(HTMLElement)), _createClass(e, [{
        key: "connectedCallback",
        value: function () {
            var t = this;
            this.getVariantData(), this.showMoreMedia(), this.variantIdChangedUnsubscriber = window.subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
                t.currentVariant = e.data.variant, t.updateMedia();
            });
        }
    }, {
        key: "disconnectedCallback",
        value: function () {
            this.variantIdChangedUnsubscriber && this.variantIdChangedUnsubscriber();
        }
    }, {
        key: "getVariantData",
        value: function () {
            this.variantData = this.variantData || JSON.parse(this.querySelector("[data-product-info-json]").textContent);
            var t = this.dataset.defaultVariantId;
            this.currentVariant = this.variantData.find(function (e) {
                return e.id == t;
            });
        }
    }, {
        key: "showMoreMedia",
        value: function () {
            var t = this;
            this.showMoreButtons.forEach(function (e) {
                e.addEventListener("click", function () {
                    t.resetMaxMediaToShow(), t.updateMedia(), t.setMaxMediaToShow(), e.classList.add("hidden-in-desktop"), e.parentElement.classList.add("hidden-in-desktop"), t.hideLessButton.classList.remove("hidden");
                });
            }), this.hideLessButton.addEventListener("click", function () {
                t.updateMedia();
                var e = t.querySelector("[data-product-show-more-media]:not(.hidden-in-desktop)");
                e.parentElement.classList.remove("hidden-in-desktop"), null == e || e.focus();
            });
        }
    }, {
    key: "updateMedia",
    value: function () {
        // Check if the viewport width is above 750 pixels
        var isAbove750px = window.matchMedia("(min-width: 750px)").matches;

        if (!isAbove750px) {
            // If the viewport width is not above 750px, skip media updates
            return;
        }

        // Proceed with media update logic if viewport width is above 750px
        var t, e = this, r = null !== (t = this.currentVariant) && void 0 !== t && t.featured_media ? 1 : 0, n = r, o = null;
        
        this.mediaSliders.forEach(function (t) {
            var i, a, s = t.nextElementSibling.querySelector("[data-product-show-more-media]");
            s && (s.classList.add("hidden-in-desktop"), s.parentElement.classList.add("hidden-in-desktop"));
            var c = t.dataset.alt;
            t.classList.add("hidden-in-desktop");
            var u = (null === (i = e.currentVariant) || void 0 === i || null === (i = i.name) || void 0 === i ? void 0 : i.startsWith(c)) || (null === (a = e.currentVariant) || void 0 === a || null === (a = a.public_title) || void 0 === a ? void 0 : a.includes(c)),
                l = u && e.maxProductMediaToShow >= r + 1;
            u && n++, l && (r++, t.classList.remove("hidden-in-desktop"), r == e.maxProductMediaToShow && s && (o = s));
        });

        n > this.maxProductMediaToShow && o && (o.classList.remove("hidden-in-desktop"), o.parentElement.classList.remove("hidden-in-desktop"));
        this.hideLessButton.classList.add("hidden");
    }
}
, {
        key: "setMaxMediaToShow",
        value: function () {
            this.maxProductMediaToShow = parseInt(this.dataset.maxMediaToShow) || 4;
        }
    }, {
        key: "resetMaxMediaToShow",
        value: function () {
            this.maxProductMediaToShow = 1e3;
        }
    }]), e;
}()), customElements.get("lta-product-materials") || customElements.define("lta-product-materials", function (t) {
    function e() {
        var t;
        return _classCallCheck(this, e), (t = _callSuper(this, e)).triggers = t.querySelectorAll("[data-trigger]"), t.contents = t.querySelectorAll("[data-content]"), t.toggleDetails(), t;
    }
    return _inherits(e, _wrapNativeSuper(HTMLElement)), _createClass(e, [{
        key: "toggleDetails",
        value: function () {
            var t = window.matchMedia("(max-width: 750px)");
            this.triggers.forEach(function (e) {
                e.addEventListener("click", function () {
                    if (t.matches) {
                        var r = e.parentElement.querySelector("[data-content]");
                        if (!r) return;
                        r.classList.contains("is-open") ? (r.style.maxHeight = "0px", requestAnimationFrame(function () {
                            r.classList.remove("is-open");
                        })) : (r.classList.add("is-open"), requestAnimationFrame(function () {
                            r.style.maxHeight = "".concat(r.scrollHeight, "px");
                        }));
                    }
                });
            });
        }
    }]), e;
}());
}


// if (window.matchMedia("(min-width: 750px)").matches) {
//     // Run the mobile-only function
//     desktopOnlyFunction();
//   var desktopEmpty = document.getElementById('mobileview');
//   desktopEmpty.innerHTML = '';
// }else{
// mobileOnlyFunction();
//   var mobileEmpty = document.getElementById('desktopview');
//   mobileEmpty.innerHTML = '';
// }

// Optional: Add an event listener to handle screen resizing
// window.addEventListener('resize', function() {
//     if (window.matchMedia("(min-width: 750px)").matches) {
//         desktopOnlyFunction();
//       var desktopEmpty = document.getElementById('mobileview');
//   desktopEmpty.innerHTML = '';
//     }else{
      
//       var mobileEmpty = document.getElementById('desktopview');
//   mobileEmpty.innerHTML = '';
//     }
// });

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-materials__item").forEach(c => {
    c.addEventListener("click", () => this.classList.toggle("open"))
  })
})
